export default __webpack_public_path__ + "static/media/hint.7db9d676.svg";